module.exports = __webpack_public_path__ + "static/3musclers2-2f1f5b6dc5bc612287f59fddfa35f24f.jpg";